export default "__VITE_ASSET__Cnga59sQ__"